/**
 * TeamAccessHome — thin satellite-app wrapper around the shared "Team Access"
 * board. Owns only the standalone-app page chrome: title, ReturnToMainAgent,
 * MainAppNav.
 *
 * The board is wired to the live access surface via TeamAccessBoardConnected
 * (GET /locations/{id}/roster + /access-requests?decidable_by=me, with
 * server-authoritative decide/grant/revoke). Home is session-less; the board's
 * composer mints the session on its first send (useDeferredFirstSend) and
 * onSessionCreated navigates into it — there is no empty-session "open
 * assistant" step, because tricorder-session creates a session WITH its first
 * message, never without one. DEV /preview keeps the fixtures.
 */

import { ReturnToMainAgent } from '@frontend/components/ReturnToMainAgent'
import { MainAppNav } from '@frontend/components/MainAppNav'
import { TeamAccessBoardConnected } from '../components/access/TeamAccessBoardConnected'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function TeamAccessHome() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="flex h-dvh flex-col bg-[var(--color-surface-canvas,#ffffff)]">
      <header className="flex items-center gap-2 border-b border-neutral-200 bg-white px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))]">
        <ReturnToMainAgent className="-ml-2" />
        <h1 className="min-w-0 flex-1 truncate text-[19px] font-semibold tracking-[-0.01em] text-neutral-900">
          {t('access.team.title')}
        </h1>
        <MainAppNav />
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto">
        <TeamAccessBoardConnected onSessionCreated={(s) => navigate(`/sessions/${s.id}`)} />
      </main>
    </div>
  )
}
